var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiselectDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160547",
    "data-name": "Group 160547",
    transform: "translate(-232 -1256)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 16,
    height: 16,
    transform: "translate(232 1256)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download-outline",
    transform: "translate(236.56 1259.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M101.16,176h.86a.86.86,0,0,1,.86.86v4.472a.86.86,0,0,1-.86.86H96.86a.86.86,0,0,1-.86-.86V176.86a.86.86,0,0,1,.86-.86h.86",
    transform: "translate(-96 -173.248)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M176,52.816l1.72,1.72,1.72-1.72M177.72,48v6.192",
    transform: "translate(-174.28 -48)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectDownloadIcon);
export default __webpack_public_path__ + "static/media/MultiselectDownload-icon.08a37034c4307af60fc4cc4fec934ae4.svg";
export { ForwardRef as ReactComponent };